"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MenuItems = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _classnames = _interopRequireDefault(require("classnames"));
var _Icons = _interopRequireDefault(require("../../baseComponents/Icons"));
var _Label = _interopRequireDefault(require("../../baseComponents/Label"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var MenuItems = exports.MenuItems = function MenuItems(props) {
  var list = props.content.map(function (el, i) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: "menuItems_".concat(i)
    }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.NavLink, {
      to: el.path,
      exact: el.exact === false ? false : true,
      activeClassName: "active"
    }, el.text), el.notification && /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
      name: "micro-glyph-bullet",
      type: "micro-glyph-teal"
    }), el.count && el.count != "" && /*#__PURE__*/_react["default"].createElement(_Label["default"], {
      colorTheme: "teal",
      shapeStyle: "stroke",
      type: "count",
      text: el.count
    }));
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "menuItems-component"
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: (0, _classnames["default"])("menu-items", props.className, {
      "disabled": props.disabled
    }),
    style: props.style
  }, list));
};
MenuItems.Proptypes = {
  content: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    path: _propTypes["default"].string,
    text: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string, _propTypes["default"].number]),
    notification: _propTypes["default"].bool,
    count: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
    exact: _propTypes["default"].bool
  })),
  className: _propTypes["default"].string,
  style: _propTypes["default"].object
};
MenuItems.defaultProps = {
  content: null,
  className: "",
  style: {}
};
var _default = exports["default"] = MenuItems;